import { jsxs as w, Fragment as T, jsx as d } from "react/jsx-runtime";
import { useStore as C } from "../../../store/index.mjs";
import M from "../../../ui-kit/theme-button.mjs";
import { useState as n } from "react";
import { BadRequest as B } from "@systemeio/util";
import { mercadoPagoCardBuyOffer as b } from "../api/mercado-pago-api.mjs";
import { MercadoPagoThreeDsModal as k } from "../three-ds/index.mjs";
function _({
  isFetching: l,
  buttonTitle: f,
  buttonDisabled: p,
  setIsFetching: a,
  preSubmit: u,
  handleBadRequest: h
}) {
  const { locale: D } = C(), [y, s] = n(!1), [i, P] = n(), [m, g] = n(), c = (o) => {
    window.location.assign(o);
  };
  return /* @__PURE__ */ w(T, { children: [
    /* @__PURE__ */ d(
      M,
      {
        disabled: p,
        type: "submit",
        onClick: async (o) => {
          o.preventDefault(), a(!0);
          try {
            const e = u();
            if (!e) return;
            const r = await window.cardPaymentBrickController.getFormData(), t = await b(
              {
                ...e,
                options: {
                  token: r.token,
                  mercadoPagoPaymentMethod: r.payment_method_id,
                  installments: r.installments
                }
              },
              D
            );
            if (t.threeDsInfo) {
              g(t.threeDsInfo), P(t.redirect), s(!0);
              return;
            }
            c(t.redirect);
          } catch (e) {
            if (e instanceof B)
              h(e);
            else
              throw e;
          } finally {
            a(!1);
          }
        },
        isFetching: l,
        children: f
      }
    ),
    m && /* @__PURE__ */ d(
      k,
      {
        opened: y,
        onComplete: () => {
          s(!1), i && c(i);
        },
        threeDsInfo: m
      }
    )
  ] });
}
export {
  _ as MercadoPagoCardPaymentButton
};
